var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hero-section-blog",
    style: {
      backgroundImage: 'url(' + _vm.cover + ')'
    }
  }, [_c('div', {
    staticClass: "shade"
  }), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-top"
  }, [_c('div', {
    staticClass: "blog-page-title heading-1"
  }, [_vm._v(" " + _vm._s(_vm.fields.field_one.value.text) + " ")]), _c('div', {
    staticClass: "blog-page-content heading-3-regular"
  }, [_vm._v(" " + _vm._s(_vm.fields.field_one.value.text2) + " ")])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }